import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

export interface ConfirmationOptions {
  catchOnCancel?: boolean;
  variant?: "danger" | "info";
  title?: string;
  content?: React.ReactNode;
  submit?: string;
  cancel?: string;
}

export interface ConfirmationDialogProps extends ConfirmationOptions {
  open: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  onExited: () => void;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps | null> = ({
  variant,
  title,
  content,
  submit,
  cancel,
  open,
  onSubmit,
  onCancel,
  onExited,
}) => {
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      open={open}
      onExited={onExited}
      aria-labelledby="confirmation-dialog-title"
    >
      <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
      <DialogContent id="confirmation-dialog-content">{content}</DialogContent>
      <DialogActions>
        {variant === "danger" && (
          <>
            <Button onClick={onCancel} color="primary">
              {cancel}
            </Button>
            <Button onClick={onSubmit} color="primary" autoFocus={true}>
              {submit}
            </Button>
          </>
        )}
        {variant === "info" && (
          <Button color="primary" onClick={onSubmit}>
            {submit}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
